import { debounce } from 'lodash';
import {
  createShipmentForLineItemsApi,
  listBatchShipmentsApi,
  listShipmentLineItemsApi,
  listShippingOptionsApi,
  updateAddressOrderLineItemStatusApi,
} from 'api/order';
import { batchShipmentListActions } from 'store/slices/batchShipmentSlice';
import { systemConfigActions } from 'store/slices/systemConfigSlice';
import { handleError } from './errorHandlerThunks';
import { listPatientOrders } from './patientThunks';

export const listBatchShipmentByPage =
  ({ page }) =>
  (dispatch, getState) => {
    const { sortOrder, filter } = getState().batchShipment;
    dispatch(batchShipmentListActions.updateCurrentPage({ page }));

    return listBatchShipmentsApi({ page, sortOrder, filter })
      .then(({ count, orders }) => {
        dispatch(batchShipmentListActions.loadBatchShipmentToPage({ count, orders, page }));
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const listShipmentLineItems =
  ({ addressDirectoryId, currentPage, partnerId, practiceId }) =>
  (dispatch) => {
    return listShipmentLineItemsApi({ addressDirectoryId, partnerId, practiceId })
      .then((response) =>
        dispatch(
          batchShipmentListActions.updateLineItemsToShipment({
            page: currentPage,
            shipmentLineItems: response.shipmentLineItems,
            count: response.count,
            addressDirectoryId,
            partnerId,
            practiceId,
          })
        )
      )
      .catch((error) => dispatch(handleError({ error })));
  };

export const updateAddressOrderLineItemStatus =
  ({ lineItemId, addressDirectoryId, status, mpi }) =>
  (dispatch) => {
    return updateAddressOrderLineItemStatusApi({ addressDirectoryId, lineItemId, status })
      .then((response) => {
        if (response) {
          dispatch(listBatchShipmentByPage({ page: 1 }));

          if (mpi && status === 'IN_BATCH_SHIPPING') {
            dispatch(listPatientOrders({ mpi }));
          }
        }

        return response;
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const createShipmentForLineItems =
  ({
    lineItemIds,
    addressDirectoryId,
    nameOnAddress,
    shippingOption,
    carrierCode,
    trackingNumber,
    shipmentMode,
    externalShipmentId,
    shipDate,
    shipTime,
    insuranceAmountInUSD,
  }) =>
  (dispatch) => {
    return createShipmentForLineItemsApi({
      addressDirectoryId,
      lineItemIds,
      nameOnAddress,
      shippingOption,
      carrierCode,
      trackingNumber,
      shipmentMode,
      externalShipmentId,
      shipDate,
      shipTime,
      insuranceAmountInUSD,
    })
      .then((response) => {
        if (response) {
          dispatch(listBatchShipmentByPage({ page: 1 }));
        }

        return response;
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const debouncedBatchShipments = debounce(({ dispatch }) => {
  return dispatch(listBatchShipmentByPage({ page: 1 })).finally(() =>
    dispatch(batchShipmentListActions.setBatchShipmentLoading(false))
  );
}, 1000);

export const listShippingOptions = () => (dispatch) =>
  listShippingOptionsApi()
    .then((shippingOptions) => {
      return dispatch(systemConfigActions.updateShippingOptions({ shippingOptions }));
    })
    .catch((error) => dispatch(handleError({ error })));

export const updateBatchShipmentSortBy =
  ({ sortBy }) =>
  (dispatch) => {
    dispatch(batchShipmentListActions.updateBatchShipmentsSortBy({ sortOrder: sortBy }));
    debouncedBatchShipments({ dispatch });
  };

export const updateBatchShipmentFilter =
  ({ filter }) =>
  (dispatch) => {
    dispatch(batchShipmentListActions.setBatchShipmentLoading(true));
    dispatch(batchShipmentListActions.updateBatchShipmentsFilter({ filter }));
    debouncedBatchShipments({ dispatch });
  };
